/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `food` - Food
* `packaging` - Packaging
 */
export type OperationReportGoodsTypeEnum = typeof OperationReportGoodsTypeEnum[keyof typeof OperationReportGoodsTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OperationReportGoodsTypeEnum = {
  food: 'food',
  packaging: 'packaging',
} as const;
